<div class="breadcrumb">
  <ng-container *ngFor="let item of items; let i = index">
    <span *ngIf="!isLastItem(i)" class="breadcrumb-link" (click)="onItemClick(item, i)">
      {{ item.label }}
    </span>
    <span *ngIf="isLastItem(i)" class="breadcrumb-current">
      {{ item.label }}
    </span>
    <span *ngIf="!isLastItem(i)" class="breadcrumb-separator">→</span>
  </ng-container>
</div>
